import { scopedKey } from "@/queries/scope";
import { observedRead, type THintTargets } from "./types";

/** The goals domain's hint rows (NG-2801). */
export const GOALS_HINTS: THintTargets = {
  // Every cached goal read in the workspace: the list and the intake choices,
  // each goal's detail and its sections (leads, linked work, datapoints), all
  // keyed under `goals`. Goals read only through Query, so the row runs with
  // `query-cache` off too.
  "goals:bank": observedRead((scope) => scopedKey(scope, "goals"), { flag: null }),
};
